import { useEffect } from 'react';

const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** CR-041: [data-reveal] 요소가 뷰포트에 들어오면 .is-in 을 붙여 떠오르게 한다. [data-count] 숫자는 카운트업. 줄어든 동작 선호면 즉시 표시 */
export function useReveal() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll<HTMLElement>('[data-reveal]'));
    const counters = Array.from(document.querySelectorAll<HTMLElement>('[data-count]'));
    if (reduced() || !('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); counters.forEach((el) => { el.textContent = el.dataset.count ?? ''; }); return; }
    const io = new IntersectionObserver((entries) => { for (const e of entries) if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach((el) => io.observe(el));
    // 큰 숫자: 보이는 순간 0 → 목표값 (easeOutCubic, 1.2s)
    const co = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue; co.unobserve(e.target);
        const el = e.target as HTMLElement; const target = Number(el.dataset.count ?? '0'); const t0 = performance.now(); const dur = 1200;
        const tick = (t: number) => { const p = Math.min(1, (t - t0) / dur); const v = Math.round(target * (1 - Math.pow(1 - p, 3))); el.textContent = String(v); if (p < 1) requestAnimationFrame(tick); };
        requestAnimationFrame(tick);
      }
    }, { threshold: 0.6 });
    counters.forEach((el) => { el.textContent = '0'; co.observe(el); });
    return () => { io.disconnect(); co.disconnect(); };
  });
}

/** CR-041: 스크롤 시차. 히어로 요소에 --sy(스크롤 px) 를 흘려 텍스트는 천천히 올라가며 흐려지고 목업은 반대로 살짝 따라온다 */
export function useScrollFx() {
  useEffect(() => {
    if (reduced()) return;
    const hero = document.querySelector<HTMLElement>('.s-hero'); if (!hero) return;
    let raf = 0;
    const apply = () => { raf = 0; const y = Math.max(0, window.scrollY); hero.style.setProperty('--sy', String(Math.min(y, 900))); };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(apply); };
    apply(); window.addEventListener('scroll', onScroll, { passive: true });
    return () => { window.removeEventListener('scroll', onScroll); if (raf) cancelAnimationFrame(raf); };
  }, []);
}
